
import {Vue, Component, Prop, Emit} from 'vue-property-decorator';
import TkDate from './fields/TkDate.vue';

@Component({
  name: 'TkDropdownPanel',
  components: {
    TkDate,
  },
})
export default class TkDropdownPanel extends Vue {
  @Prop({ required: true })
  private columns!: any[];

  @Prop({ required: true, type: String })
  private title!: string;
  
  @Prop({ default: () => ({}) })
  private row!: any;
  
  @Prop({ default: 'view' })
  private mode!: string;

  /**
   * Verifica se o campo tem um valor para exibir
   */
  private hasValue(column: any): boolean {
    // Sempre retorna true para exibir todos os campos
    return true;
  }

  /**
   * Obtém o valor do campo para exibição
   */
  private getValue(column: any): any {
    if (!this.row) return '';
    
    // Se for um campo de seleção, retorna um objeto com valueField e descriptionField
    if (column.tag === 'TkSelect') {
      return this.getSelectedValue(column);
    }
    
    return this.row[column.value] || ''; // Retorna string vazia se o valor for null/undefined
  }

  /**
   * Obtém o valor selecionado para campos TkSelect
   */
  private getSelectedValue(column: any) {
    let selected: any = {};
    
    if (this.row[column.valueField]) {
      selected[column.valueField] = this.row[column.valueField];
      selected[column.descriptionField] = this.row[column.descriptionField];
    } else {
      selected[column.valueField] = undefined;
      selected[column.descriptionField] = undefined;
    }
    
    return selected;
  }

  /**
   * Obtém as propriedades de binding para o componente
   */
  private getBindProps(column: any): any {
    const bindProps: any = {};
    
    // Copia todas as propriedades do column para bindProps, exceto as comuns
    const commonProps = ['tag', 'showOnForm', 'text', 'value', 'cols', 'readonly'];
    
    Object.keys(column).forEach(key => {
      if (!commonProps.includes(key)) {
        bindProps[key] = column[key];
      }
    });
    
    return bindProps;
  }

  /**
   * Manipula a alteração de um campo
   */
  @Emit('field-change')
  private onFieldChange(column: any, value: any) {
    return [column, value];
  }

  /**
   * Manipula o evento after-reload de um campo
   */
  @Emit('field-after-reload')
  private onFieldAfterReload(event: any, column: any) {
    return [event, column];
  }

  /**
   * Manipula o evento update-select-value de um campo
   */
  @Emit('update-select-value')
  private onUpdateSelectValue(event: any, column: any) {
    return [event, column];
  }
  
}
